import { useVirtualizer } from '@tanstack/react-virtual';
import { useEffect, useRef, useState } from 'react';
import { useScrollable } from '../elements/Scroll/usePopoverScrollable';
export function useVirtualList(count, getInitialItemHeight, externalScrollRef) {
    const containerRef = useRef(null);
    const isExternal = Boolean(externalScrollRef);
    const scrollViewport = useScrollable(containerRef, !isExternal, 'y');
    const virtualizer = useVirtualizer({
        count,
        getScrollElement: () => {
            if (externalScrollRef === null || externalScrollRef === void 0 ? void 0 : externalScrollRef.current) {
                return externalScrollRef.current;
            }
            return scrollViewport !== null && scrollViewport !== void 0 ? scrollViewport : containerRef.current;
        },
        estimateSize: getInitialItemHeight,
        overscan: 5
    });
    const [viewportHeight, setViewportHeight] = useState(0);
    useEffect(() => {
        var _a, _b;
        const element = (_b = (_a = externalScrollRef === null || externalScrollRef === void 0 ? void 0 : externalScrollRef.current) !== null && _a !== void 0 ? _a : scrollViewport) !== null && _b !== void 0 ? _b : containerRef.current;
        if (!element) {
            return;
        }
        const updateHeight = () => {
            setViewportHeight(element.clientHeight);
        };
        updateHeight();
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(element);
        return () => {
            resizeObserver.disconnect();
        };
    }, [scrollViewport, externalScrollRef]);
    const getViewportHeight = () => viewportHeight;
    const getVirtualListStyle = () => ({
        height: virtualizer.getTotalSize(),
        position: 'relative'
    });
    const getVirtualItemStyle = (item) => ({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: `translateY(${item.start}px)`
    });
    return {
        containerRef,
        measureElement: virtualizer.measureElement,
        getVirtualList: virtualizer.getVirtualItems,
        getViewportHeight,
        getVirtualListStyle,
        getVirtualItemStyle
    };
}
